'use client';
import { useTranslations } from '@dealerportal/i18n/client';
import './PrintCouponButtonStyles.css';

// biome-ignore lint/complexity/noBannedTypes: <explanation>
type Props = {};

function printHandler() {
  window.print();
}

export const PrintCouponButton: React.FC<Props> = (Props) => {
  const t = useTranslations('ui');

  return (
    <>
      {/* {renderButton && ( */}
      <button className="printCoupon" onClick={printHandler}>
        {t('printCoupon')}
      </button>
      {/* )} */}
    </>
  );
};

export default PrintCouponButton;
